import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import "./DriverData.css";
import DriverImg from "../../../components/images/driver.jpg"; // Import driver image

export default function DriverData({ drivers, loading, error }) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const driverParam = searchParams.get("driver");
  const [searchTerm, setSearchTerm] = useState(driverParam ? driverParam.replace("_", " ") : ""); // Set initial search term

  // Filter driver list based on search term
  const filteredDrivers = drivers.filter((driver) => driver.name.toLowerCase().includes(searchTerm.toLowerCase())).slice(0, 10); // Show up to 10 results

  return (
    <div className="driver-data-container">
      <h1>Search Drivers</h1>

      {/* Search Input */}
      <input type="text" className="form-control" placeholder="Search by driver name..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />

      {/* Render error, loader, or driver cards */}
      {error ? (
        <div className="error-message">{error}</div>
      ) : loading ? (
        <div className="socket">
          <div className="gel center-gel">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c1 r1">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
        </div>
      ) : (
        <div className="card-columns">
          {filteredDrivers.map((driver) => (
            <div className="card" key={driver.id}>
              <img className="card-img-top" src={DriverImg} alt="Driver" />
              <div className="card-body">
                <div className="card-title h5 text-center">{driver.name}</div>
                <div className="row">
                  <div className="col-6">
                    <div className="text-value">{driver.driverClass}</div>
                    <small className="text-uppercase text-muted">Driver Class</small>
                  </div>
                </div>
                <div className="text-center mt-3">
                  <a href={`/driver/${driver.id}`} className="btn btn-dark">
                    View Data
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
